interface OnboardingStepTrackProps {
  currentStep: number;
  totalSteps?: number;
}

export function OnboardingStepTrack({ currentStep, totalSteps = 4 }: OnboardingStepTrackProps) {
  const elements: React.ReactNode[] = [];

  for (let i = 0; i < totalSteps; i++) {
    const isCompleted = i < currentStep;
    const isActive = i === currentStep;

    elements.push(
      <div
        key={`dot-${i}`}
        className={`onboarding-track__dot${isActive ? ' onboarding-track__dot--active' : ''}${isCompleted ? ' onboarding-track__dot--completed' : ''}`}
        aria-current={isActive ? 'step' : undefined}
      />
    );

    if (i < totalSteps - 1) {
      elements.push(
        <div
          key={`line-${i}`}
          className={`onboarding-track__line${i < currentStep ? ' onboarding-track__line--completed' : ''}`}
        />
      );
    }
  }

  return (
    <div className="onboarding-track" role="navigation" aria-label="Onboarding progress">
      {elements}
    </div>
  );
}
